import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/app/App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {theme} from "./shared/theme";
import {ThemeProvider} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import {Provider} from "react-redux";
import {store} from "./store/store";
import 'moment/locale/it';
import itLocale from "date-fns/locale/it";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import {LocalizedUtils} from "./shared/utils/dateUtils";
import {ToastContainer} from "react-toastify";
import {ToastCloseButton} from "./shared/components/toast/toast-close-button/ToastCloseButton";
import ErrorBoundary from "./components/error/ErrorBoundary";
import ErrorPage from "./components/error/ErrorPage";

ReactDOM.render(
    <Provider store={store}>
        <ErrorBoundary fallback={<ErrorPage/>}>
            <ToastContainer autoClose={4000}
                            hideProgressBar
                            closeButton={ToastCloseButton}/>
            <BrowserRouter basename="/">
                <ThemeProvider theme={theme}>
                    <CssBaseline/>
                    <MuiPickersUtilsProvider utils={LocalizedUtils} locale={itLocale}>
                        <App/>
                    </MuiPickersUtilsProvider>
                </ThemeProvider>
            </BrowserRouter>
        </ErrorBoundary>
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
